import React from "react";
import Image from "next/image";
import styles from "./SchoolTestimonials.module.css";
import { Quote } from "lucide-react";

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface FacultyCard {
  id: number;
  title_description: TileDescription;
  images: Image[];
}

interface SchoolEducatorDetail {
  id: number;
  position: string;
  title_description: FacultyCard;
}

interface SchoolTestimonialsProps {
  data: SchoolEducatorDetail;
  isUgpg?: boolean;
}

const SchoolTestimonials: React.FC<SchoolTestimonialsProps> = ({
  data,
  isUgpg = false,
}) => {
  return (
    <div className={isUgpg ? styles.ugpgTestnomial : styles.testimonialSection}>
      <div className="container">
        <div className={styles.testimonialCard}>
          <div className={styles.imageContainer}>
            {data?.title_description?.images?.[0]?.url && (
              <Image
                src={data?.title_description?.images[0].url}
                alt={
                  data?.title_description?.images[0]?.alternativeText ||
                  "Academic Image"
                }
                title={
                  data?.title_description?.images[0]?.alternativeText ||
                  "Academic Image"
                }
                width={280}
                height={280}
                className={styles.profileImage}
              />
            )}
            <div className={styles.quoteIcon}>
              <Quote />
            </div>
          </div>
          <div className={styles.content}>
            <p className={isUgpg ? styles.ugQuote : styles.quote}>
              {data?.title_description?.title_description?.description}
            </p>
            <strong className={isUgpg ? styles.ugpgName : styles.name}>
              {data?.title_description?.title_description?.title}
            </strong>

            <span
              className={isUgpg ? styles.ugpgDesignation : styles.designation}
            >
              {data?.position}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolTestimonials;
